import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  useTheme,
} from '@mui/material';
import { X } from 'lucide-react';
import { ServiceResourceMapping } from '../../types/resource';

interface ResourceServicesProps {
  services: ServiceResourceMapping[];
  onRemoveService?: (serviceId: number) => void;
}

const ResourceServices: React.FC<ResourceServicesProps> = ({ services, onRemoveService }) => {
  const theme = useTheme();

  if (services.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 2 }}>
        <Typography color="text.secondary">No services assigned to this resource</Typography>
      </Box>
    );
  }

  return (
    <Paper variant="outlined">
      <List disablePadding>
        {services.map(({ id, services: service }) => (
          <ListItem
            key={id}
            divider
            sx={{
              '&:last-child': {
                borderBottom: 'none',
              },
            }}
          >
            <ListItemText
              primary={service.name}
              secondary={
                <Box sx={{ mt: 0.5 }}>
                  <Chip
                    label={`${service.duration} min`}
                    size="small"
                    sx={{
                      backgroundColor: `${theme.palette.primary.main}15`,
                      color: theme.palette.primary.main,
                      fontWeight: 500,
                    }}
                  />
                </Box>
              }
              secondaryTypographyProps={{ component: 'div' }}
            />
            {onRemoveService && (
              <ListItemSecondaryAction>
                <IconButton edge="end" size="small" onClick={() => onRemoveService(service.id)}>
                  <X size={16} />
                </IconButton>
              </ListItemSecondaryAction>
            )}
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default ResourceServices;
